import { InfiniteData, useQueryClient } from "@tanstack/react-query";
import CoachProgramsService from "../../../services/CoachProgramsService";
import { COACH_PROGRAMS_LIST_QUERY_KEY } from "../CoachProgramsListScreen";
import { ProgramStatus } from "../../../constants";
import {
  IPaginatedListOfProgramDto,
  IProgramsCountDto,
  ProgramDto,
} from "@growth-machine-llc/stridist-api-client";
import {
  predicateQueryKeyByParams,
  useOptimisticUpdateMutation,
} from "../../../hooks/useOptimisticUpdateMutation";
import { INFINITE_PAGINATED_DATA_UPDATERS } from "../../../utils/optimisticUpdate";
import { COACH_PROGRAMS_COUNT_QUERY_KEY } from "../../../wrappers/router/coach/CoachProgramsListWrapper";

export const useRestoreProgramMutation = (status: ProgramStatus) => {
  const filterOutProgram = INFINITE_PAGINATED_DATA_UPDATERS.filterOutItem;
  const queryClient = useQueryClient();

  return useOptimisticUpdateMutation({
    mutationFn: CoachProgramsService.restoreProgram,
    queryKey: [COACH_PROGRAMS_LIST_QUERY_KEY],
    optimisticUpdater: {
      updateFn: (oldData: InfiniteData<IPaginatedListOfProgramDto>, params) =>
        filterOutProgram<ProgramDto>(oldData, params.programId),
      predicateFn: (queryKey) =>
        predicateQueryKeyByParams(queryKey, {
          status: status,
        }),
    },
    invalidateQueryOptions: {
      enabled: true,
      predicateFn: (queryKey) =>
        // Invalidating all other tabs except the `ARCHIVED` tab
        !predicateQueryKeyByParams(queryKey, {
          status: status,
        }),
    },
    options: {
      onSuccess: () => {
        if (status === ProgramStatus.DRAFT) {
          queryClient.setQueryData<IProgramsCountDto>(
            [COACH_PROGRAMS_COUNT_QUERY_KEY],
            (prev) => (prev ? { draft: prev.draft - 1 } : prev),
          );
        }
      },
    },
  });
};
